import { Input } from "antd";
import { InputProps } from "antd/lib";
import React from "react";

const formatPhone = (str: string) => {
  let res = str.replace(/\D/g, "");
  if (str[0] === "+") {
    res = "+" + res;
  }
  return res;
};

export const UI_ITOPhoneInput = (props: InputProps) => {
  const { onChange } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEvent = e;
    newEvent.target.value = formatPhone(newEvent.target.value);

    if (onChange) {
      onChange(newEvent);
    }
  };
  return <Input {...props} onChange={handleChange} />;
};
